// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -1734173455
// </auto-generated>
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { SmartListCriteria, SmartListResult } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';
import { Observable, Subject } from 'rxjs';

import { FileResponse } from 'carehub-shared/fileResponse';
import { map } from 'rxjs/operators';
import { UploadObject } from '../shared/models/uploadobject';
import { BlobResult } from './models/common/blobresult';
import { DescribedItem } from './models/common/describeditem';
import { Reimbursement } from './models/finance/reimbursement';
import { Document } from './models/member/document';
import { CaseSummary } from './models/membercase/casesummary';
import { CaseTimelineSummary } from './models/membercase/casetimelinesummary';
import { ClaimsSearch } from './models/membercase/claimssearch';
import { Consult } from './models/membercase/consult';
import { Escalation } from './models/membercase/escalation';
import { InquiryWithNotes } from './models/membercase/inquirywithnotes';
import { MedicalRecord } from './models/membercase/medicalrecord';
import { MemberAppointment } from './models/membercase/memberappointment';
import { MemberCase } from './models/membercase/membercase';
import { MemberCaseQueueEntry } from './models/membercase/membercasequeueentry';
import { MemberPhysician } from './models/membercase/memberphysician';
import { MemberServiceValidationDates } from './models/membercase/memberservicevalidationdates';
import { PhysicalTherapy } from './models/membercase/physicaltherapy';
import { ProviderPlacement } from './models/membercase/providerplacement';
import { ProviderRec } from './models/membercase/providerrec';
import { ProviderRecStatus } from './models/membercase/providerrecstatus';
import { RecommendedProviderClinics } from './models/membercase/recommendedproviderclinics';
import { ReimbursableService } from './models/membercase/reimbursableservice';
import { Service } from './models/membercase/service';
import { ServiceCompletionState } from './models/membercase/servicecompletionstate';
import { ServiceType } from './models/membercase/servicetype';
import { ServiceTypeForClaim } from './models/membercase/servicetypeforclaim';
import { Surgery } from './models/membercase/surgery';
import { Testing } from './models/membercase/testing';
import { IncompleteService } from './models/nonentity/incompleteservice';
import { MrrDocumentResponse } from './models/nonentity/mrrdocumentresponse';
import { Task } from './models/task/task';

export interface getFilteredCases_Filter {
  caseStatusId: number;
  clientId: string;
  careAdvocateId: string;
  teamId: string;
  memberFirstName: string;
  memberLastName: string;
  productId: number;
  procedureName: string;
  procedureCategory: string;
  servicePresent: boolean;
  reimbursementsPresent: boolean;
}

export interface searchCasesForClaims_Filter {
  memberFirstName: string;
  memberLastName: string;
  memberBirthdate: string;
}

export interface getCasesInQueue_Filter {
  caseNumberFilter: string;
  statusFilter: string;
  memberNameFilter: string;
  clientFilter: string;
  procedureFilter: string;
}

export interface getMemberAppointmentsByUserId_Filter {
  SelectedDate: string;
}

export interface getTasks_Filter {
  noOlderThanDays: number;
  includeCompleted: boolean;
  createdDate: string;
  followUpDate: string;
  completedDate: string;
  resolutionChannelId: number;
  participantTypeId: number;
  note: string;
  taskTypeId: number;
  procedureItemId: number;
  memberName: string;
  taskPriorityId: number;
  userId: string;
}

export interface getTaskHistoryById_Filter {
  noOlderThanDays: number;
  includeCompleted: boolean;
  createdDate: string;
  followUpDate: string;
  completedDate: string;
  resolutionChannelId: number;
  participantTypeId: number;
  note: string;
  taskTypeId: number;
  procedureItemId: number;
  memberName: string;
  taskPriorityId: number;
  userId: string;
}

export interface getMemberPhysician_Filter {
  memberPhysicianId: string;
}

export interface getProviderRecsQueue_Filter {
  providerRecStatus: number;
  procedureItemCategoryId: number;
  assignmentStatuses: number[];
  assignedToUserId: string;
  procedureItemId: number;
  submittedById: string;
}

export interface getCaseTimelineById_Filter {
  recordType: string;
  timestamp: string;
  userName: string;
}

export interface hasAbilityToCreateServiceAfterTermination_Filter {
  dateOfService: string;
}

export interface getDocumentsByCaseId_Filter {
  documentTypeId: number;
}

export interface getMemberCaseById_Filter {
  includeChildren: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MemberCasesApiService {
  constructor(protected http: HttpClient) {}

  getFilteredCases(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getFilteredCases_Filter>
  ): Observable<SmartListResult<CaseSummary>> {
    let url = environment.chiliSauceApiRoot + `/api/MemberCases/filtered`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<CaseSummary>>(url, { params: params });
  }

  getFilteredCaseStatuses(
    memberCaseGuid: string,
    memberCaseStatusId: number,
    isEligible: boolean
  ): Observable<DescribedItem[]> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${memberCaseGuid}/${memberCaseStatusId}/${isEligible}/getFilteredCaseStatuses`;
    return this.http.get<DescribedItem[]>(url);
  }

  getLinkableCases(
    memberCaseGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<MemberCase>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${memberCaseGuid}/linkableCases`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<MemberCase>>(url);
  }

  searchCasesForClaims(
    criteria?: SmartListCriteria,
    queryParams?: Partial<searchCasesForClaims_Filter>
  ): Observable<SmartListResult<ClaimsSearch>> {
    let url =
      environment.chiliSauceApiRoot + `/api/MemberCases/searchCasesForClaims`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ClaimsSearch>>(url, {
      params: params,
    });
  }

  getCasesInQueue(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getCasesInQueue_Filter>
  ): Observable<SmartListResult<MemberCaseQueueEntry>> {
    let url = environment.chiliSauceApiRoot + `/api/MemberCases/queue`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<MemberCaseQueueEntry>>(url, {
      params: params,
    });
  }

  getMemberAppointmentsByUserId(
    queryParams?: Partial<getMemberAppointmentsByUserId_Filter>
  ): Observable<MemberAppointment[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/MemberCases/member-appointments`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<MemberAppointment[]>(url, { params: params });
  }

  getTasks(
    caseGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getTasks_Filter>
  ): Observable<SmartListResult<Task>> {
    let url =
      environment.chiliSauceApiRoot + `/api/MemberCases/${caseGuid}/tasks`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<Task>>(url, { params: params });
  }

  getTaskHistoryById(
    caseGuid: string,
    taskGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getTaskHistoryById_Filter>
  ): Observable<SmartListResult<Task>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/task/timeline/${taskGuid}`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<Task>>(url, { params: params });
  }

  getMemberPhysician(
    caseGuid: string,
    queryParams?: Partial<getMemberPhysician_Filter>
  ): Observable<MemberPhysician> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/memberphysician`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<MemberPhysician>(url, { params: params });
  }

  getMemberCaseServices(caseGuid: string): Observable<Service[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/MemberCases/${caseGuid}/services`;
    return this.http.get<Service[]>(url);
  }

  createMemberCaseServices(
    serviceType: ServiceType,
    caseGuid: string
  ): Observable<ServiceType> {
    const url =
      environment.chiliSauceApiRoot + `/api/MemberCases/${caseGuid}/services`;
    return this.http.post<ServiceType>(url, serviceType);
  }

  getMemberCaseProviderRec(caseGuid: string): Observable<ProviderRec[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/providerrec`;
    return this.http.get<ProviderRec[]>(url);
  }

  getMemberCaseReimbursableServices(
    caseGuid: string
  ): Observable<ReimbursableService[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/reimbursableservices`;
    return this.http.get<ReimbursableService[]>(url);
  }

  updateMemberCaseReimbursableServices(
    caseGuid: string,
    services: ReimbursableService[]
  ): Observable<ReimbursableService[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/reimbursableservices`;
    return this.http.post<ReimbursableService[]>(url, services);
  }

  createMemberCaseServiceForClaim(
    serviceType: ServiceTypeForClaim,
    caseGuid: string
  ): Observable<ServiceType> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/claim`;
    return this.http.post<ServiceType>(url, serviceType);
  }

  getInquiriesByCaseId(
    caseGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<InquiryWithNotes>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/inquiries`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<InquiryWithNotes>>(url);
  }

  updateInquiries(
    inquiries: InquiryWithNotes[],
    caseGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/inquiries`;
    return this.http.put<any>(url, inquiries);
  }

  deleteInquiryById(
    memberCaseGuid: string,
    inquiryGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${memberCaseGuid}/services/inquiries/${inquiryGuid}`;
    return this.http.delete(url);
  }

  getMedicalRecordsByCaseId(
    caseGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<MedicalRecord>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/medicalrecords`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<MedicalRecord>>(url);
  }

  deleteProviderRec(
    memberCaseGuid: string,
    providerRecGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${memberCaseGuid}/services/providerrecs/${providerRecGuid}`;
    return this.http.delete(url);
  }

  hasAbilityToEditCaseProcedure(caseGuid: string): Observable<number> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/providerrecs/completed`;
    return this.http.get<number>(url);
  }

  getProviderRecsByCaseId(
    caseGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<ProviderPlacement>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/providerrecs`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<ProviderPlacement>>(url);
  }

  updateRecommendedProvider(
    caseGuid: string,
    providerRecs: ProviderRec
  ): Observable<RecommendedProviderClinics> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/providerrecs`;
    return this.http.post<RecommendedProviderClinics>(url, providerRecs);
  }

  getProviderRecsQueue(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getProviderRecsQueue_Filter>
  ): Observable<SmartListResult<ProviderPlacement>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/services/providerrecs/queue`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ProviderPlacement>>(url, {
      params: params,
    });
  }

  getProviderRecById(providerRecId: string): Observable<ProviderPlacement> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/services/providerrecs/queue/${providerRecId}`;
    return this.http.get<ProviderPlacement>(url);
  }

  approveProviderRec(providerRecGuid: string): Observable<ProviderPlacement> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/services/providerrecs/queue/${providerRecGuid}/approve`;
    return this.http.put<ProviderPlacement>(url, {});
  }

  rejectProviderRec(
    providerRec: ProviderPlacement,
    providerRecGuid: string
  ): Observable<ProviderPlacement> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/services/providerrecs/queue/${providerRecGuid}/reject`;
    return this.http.put<ProviderPlacement>(url, providerRec);
  }

  escalateMemberCase(
    escalation: Escalation,
    caseGuid: string
  ): Observable<Escalation> {
    const url =
      environment.chiliSauceApiRoot + `/api/MemberCases/${caseGuid}/escalate`;
    return this.http.post<Escalation>(url, escalation);
  }

  deescalateMemberCase(caseGuid: string): Observable<Escalation> {
    const url =
      environment.chiliSauceApiRoot + `/api/MemberCases/${caseGuid}/deescalate`;
    return this.http.post<Escalation>(url, {});
  }

  reopenMemberCase(
    memberCase: MemberCase,
    memberCaseGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${memberCaseGuid}/reopen`;
    return this.http.put<any>(url, memberCase);
  }

  getCaseTimelineById(
    caseGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getCaseTimelineById_Filter>
  ): Observable<SmartListResult<CaseTimelineSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/case/timeline`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<CaseTimelineSummary>>(url, {
      params: params,
    });
  }

  exportCaseTimelineById(caseGuid: string): Observable<FileResponse> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/case/timeline/export`;
    return this.http
      .get(url, { responseType: 'blob', observe: 'response' })
      .pipe(map(Utils.asFileResult));
  }

  updateProviderRecStatus(
    caseGuid: string,
    providerRecGuid: string,
    statusDto: ProviderRecStatus
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/providerrecs/${providerRecGuid}/status`;
    return this.http.put<any>(url, statusDto);
  }

  updateCompletionState(
    completionStatus: ServiceCompletionState,
    caseGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/completionStatus`;
    return this.http.put<any>(url, completionStatus);
  }

  getConsultsByCaseId(
    caseGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Consult>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/consults`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Consult>>(url);
  }

  getPhysicalTherapiesByCaseId(
    caseGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<PhysicalTherapy>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/physicaltherapies`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<PhysicalTherapy>>(url);
  }

  getTestingsByCaseId(
    caseGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Testing>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/testings`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Testing>>(url);
  }

  getSurgeriesByCaseId(
    caseGuid: string,
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Surgery>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/surgeries`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Surgery>>(url);
  }

  hasAbilityToCreateServiceAfterTermination(
    caseGuid: string,
    queryParams?: Partial<hasAbilityToCreateServiceAfterTermination_Filter>
  ): Observable<number> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/hasAbilityToCreateServiceAfterTermination`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<number>(url, { params: params });
  }

  deleteSurgery(surgeryGuid: string, caseGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/surgeries/${surgeryGuid}`;
    return this.http.delete(url);
  }

  deleteConsult(consultGuid: string, caseGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/consults/${consultGuid}`;
    return this.http.delete(url);
  }

  deletePhysicalTherapy(
    physicalTherapyGuid: string,
    caseGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/physicaltherapies/${physicalTherapyGuid}`;
    return this.http.delete(url);
  }

  deleteTesting(testingGuid: string, caseGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/services/testings/${testingGuid}`;
    return this.http.delete(url);
  }

  getDocumentsByCaseId(
    caseGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getDocumentsByCaseId_Filter>
  ): Observable<SmartListResult<Document>> {
    let url =
      environment.chiliSauceApiRoot + `/api/MemberCases/${caseGuid}/documents`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<Document>>(url, { params: params });
  }

  addCaseDocuments(
    caseGuid: string,
    documents: Document[]
  ): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/MemberCases/${caseGuid}/documents`;
    return this.http.post<Document[]>(url, documents);
  }

  getReimbursementsByCaseId(caseGuid: string): Observable<Reimbursement[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/reimbursements`;
    return this.http.get<Reimbursement[]>(url);
  }

  addReimbursement(
    caseGuid: string,
    reimbursement: Reimbursement
  ): Observable<Reimbursement> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/reimbursements`;
    return this.http.post<Reimbursement>(url, reimbursement);
  }

  getReimbursement(
    reimbursementId: string,
    caseGuid: string
  ): Observable<Reimbursement> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/reimbursements/${reimbursementId}`;
    return this.http.get<Reimbursement>(url);
  }

  updateReimbursement(
    caseGuid: string,
    reimbursement: Reimbursement,
    reimbursementId: string
  ): Observable<Reimbursement> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseGuid}/reimbursements/${reimbursementId}`;
    return this.http.put<Reimbursement>(url, reimbursement);
  }

  uploadDocument(upload: UploadObject, metadata: any): Subject<void> {
    const url = environment.chiliSauceApiRoot + `/api/MemberCases/upload`;

    if (!upload.file) {
      console.warn('no file specified to upload');
      return;
    }

    const subject = new Subject<void>();
    const fileToUpload = upload.file;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    let headers: HttpHeaders = null;
    if (metadata) {
      headers = new HttpHeaders({
        UploadMetadata: JSON.stringify(metadata),
      });
    }

    this.http
      .post(url, formData, {
        reportProgress: true,
        observe: 'events',
        headers: headers,
      })
      .subscribe((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          upload.progress = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          const response = <BlobResult>event.body;
          upload.url = response.blobAddress;
          subject.next();
          subject.complete();
        }
      });

    return subject;
  }

  getMemberCaseById(
    memberCaseGuid: string,
    queryParams?: Partial<getMemberCaseById_Filter>
  ): Observable<MemberCase> {
    const url =
      environment.chiliSauceApiRoot + `/api/MemberCases/${memberCaseGuid}`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<MemberCase>(url, { params: params });
  }

  updateMemberCase(
    memberCase: MemberCase,
    memberCaseGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/MemberCases/${memberCaseGuid}`;
    return this.http.put<any>(url, memberCase);
  }

  addMemberCase(newMemberCase: MemberCase): Observable<MemberCase> {
    const url = environment.chiliSauceApiRoot + `/api/MemberCases`;
    return this.http.post<MemberCase>(url, newMemberCase);
  }

  getIncompleteCaseServices(
    memberCaseGuid: string
  ): Observable<IncompleteService[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${memberCaseGuid}/services/incomplete`;
    return this.http.get<IncompleteService[]>(url);
  }

  getClientContractDates(
    memberId: string,
    memberCaseId: string
  ): Observable<MemberServiceValidationDates[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${memberId}/clientContractDates/${memberCaseId}/clientContractDates`;
    return this.http.get<MemberServiceValidationDates[]>(url);
  }

  processPostProviderFinalizationSteps(caseId: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseId}/processPostProviderFinalizationSteps`;
    return this.http.post<any>(url, {});
  }

  sendMedicalRecordReleaseDocument(
    caseId: string
  ): Observable<MrrDocumentResponse> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/MemberCases/${caseId}/sendMedicalRecordReleaseDocument`;
    return this.http.get<MrrDocumentResponse>(url);
  }
}
